export default "My thoughts and reflections with regards to some big topics with The Street King.";